var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.toPath()}}},[_c('img',{style:({width: _vm.width, height: _vm.height}),attrs:{"src":_vm.imgSrc}}),_c('div',{staticClass:"img-title",style:({width: `calc(${_vm.width} - 20px)`})},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }